export const DrivesTabsEnum = {
  DRIVES: 0,
  MY_WORKSPACE: 1,
  SHARED_WITH_ME: 2,
};

export default DrivesTabsEnum;
